import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Grid from '@material-ui/core/Grid';
import { Tabs, Tab } from "@material-ui/core";

import { Wrapper, WrapperPartners, WrapperTabs, Partners, WrappLoadMore } from "./styles";
import { Container } from "../../components/design/layout/container";
import { Headline } from "../../components/design/foundation/headline";
import ButtonSelectState from "../../components/patterns/button-select-state";
import ActivePromotions from "../../components/design/data-dispay/button/active-promotions";
import Button from "../../components/design/form/button";
import ProductBox from "../../components/design/layout/product-box";

import { NothingMessage } from "../../components/ui/nothing-message";

import OfferService from "../../services/Offer";

import loadImage from "../../utils/LoadImage";
import ProductLoader from "../../components/design/layout/loader/product";

const TabPanel = (props) => {

    const { children, value, index, ...other } = props;

    return (

        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    {children}
                </>
            )}
        </div>

    )
}

function Offers({ website }) {
    const [tabValue, setTabValue] = useState(0);
    const [offerTop, setOfferTop] = useState([]);
    const [limitTop, setLimitTop] = useState(8);
    const [offerHighlight, setOfferHighlight] = useState([]);
    const [limitHighlight, setLimitHighlight] = useState(8);
    const [offerByUf, setOfferByUf] = useState([]);
    const [limitByUf, setLimitByUf] = useState(8);

    // * Loading States
    const [isLoading, setIsLoading] = useState(true);

    // * Material UI Tabs
    // * Props Tab
    function tabProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    // * Material UI Tabs
    // * On Change Tab
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const loadMoreTop = () => {
        const newLimit = limitTop + 8;
        setLimitTop(newLimit);
    }

    const loadMoreHighlight = () => {
        const newLimit = limitHighlight + 8;
        setLimitHighlight(newLimit);
    }

    const loadMoreUf = () => {
        const newLimit = limitByUf + 8;
        setLimitByUf(newLimit);
    }

    const handleInitialOffers = useCallback(() => {
        const offerService = new OfferService();

        offerService.findByTop({ limit: limitTop, onUsSearch: 'S' }).then((response) => {
            setOfferTop(response.data.payload);

            if (response.data.payload) {
                setIsLoading(status => status = false);
            }
        });

        offerService.listBySearch({ limit: limitHighlight, tag: 'destaque', onUsSearch: 'S' }).then((response) => {
            setOfferHighlight(response.data.payload);

            if (response.data.payload) {
                setIsLoading(status => status = false);
            }
        });

        offerService.listBySearch({ limit: limitByUf, onUsSearch: 'S' }).then((response) => {
            setOfferByUf(response.data.payload);

            if (response.data.payload) {
                setIsLoading(status => status = false);
            }
        });

    }, [limitTop, limitHighlight, limitByUf]);

    useEffect(() => {
        handleInitialOffers();
    }, [handleInitialOffers]);

    return (
        <Wrapper>
            <ButtonSelectState theme={website} title="Informe seu estado" link="/lista-estados" />
            <Container withContainer={true} className="ContainerBottom">
                <ActivePromotions theme={website} link="/ofertas-ativas" />
            </Container>



            <WrapperTabs className="_tabs">
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="Tabs My Sales"
                    className={`_material-tabs MaterialTabs style-${website}`}
                >
                    <Tab label="Mais populares" {...tabProps(0)} />
                    <Tab label="Perto de mim" {...tabProps(1)} />
                    <Tab label="Em destaque" {...tabProps(2)} />
                </Tabs>

                <TabPanel value={tabValue} index={0} className="tabpanel">
                    <Container withContainer={true}>
                        <WrapperPartners>
                            <Partners>

                                {isLoading && (
                                    <Grid container spacing={0}>
                                        {[0, 1, 2, 3].map((item, i) =>
                                            <Grid key={`${item}-${i + 1}`} item xs={6}>
                                                <ProductLoader />
                                            </Grid>
                                        )}
                                    </Grid>
                                )}

                                <Grid container spacing={0}>
                                    {!!offerTop.length
                                        ? offerTop.map((item, i) => (
                                            <Grid key={`${item._id}-${i}`} item xs={6}>
                                                <ProductBox
                                                    gridMargin={5}
                                                    productId={item._id}
                                                    discountValue={item.descont ? item.descont : null}
                                                    productTitle={item.titulo}
                                                    image={loadImage({ imageCode: item.imagens[0] })}
                                                    productPrice={item.oferta}
                                                    productType={item.tipo_oferta}
                                                    priceColor={props => props.theme[website]?.components.productBox.priceColor}
                                                    announcedBy={item.empresa ? website : 'parceiro'}
                                                    company={website}
                                                />
                                            </Grid>
                                        ))
                                        : <NothingMessage>
                                            Nenhuma oferta encontrada em Mais Populares.
                                        </NothingMessage>}
                                </Grid>
                                <WrappLoadMore>
                                    {limitTop <= offerTop.length && (
                                        <Button
                                            styleType="bordered"
                                            buttonSize="small"
                                            buttonColor={props => props.theme[website]?.button.background}
                                            textColor={props => props.theme[website]?.button.color}
                                            borderColor={props => props.theme[website]?.button.background}
                                            buttonText="Mostrar mais ofertas"
                                            maxWidth={200}
                                            onClick={() => loadMoreTop()}
                                        />
                                    )}
                                </WrappLoadMore>
                            </Partners>
                        </WrapperPartners>
                    </Container>
                </TabPanel>

                <TabPanel value={tabValue} index={1} className="tabpanel">
                    <Container withContainer={true}>
                        <WrapperPartners>
                            <Partners>

                                {isLoading && (<Grid container spacing={0}>
                                    {[0, 1, 2, 3].map((item, i) =>
                                        <Grid key={`${item}-${i + 1}`} item xs={6}>
                                            <ProductLoader />
                                        </Grid>
                                    )}
                                </Grid>)}

                                <Grid container spacing={0}>
                                    {!!offerByUf.length ? offerByUf.map((item, i) => (
                                        <Grid key={`${item._id}-${i}`} item xs={6}>
                                            <ProductBox
                                                gridMargin={5}
                                                productId={item._id}
                                                discountValue={item.descont ? item.descont : null}
                                                productTitle={item.titulo}
                                                image={loadImage({ imageCode: item.imagens[0] })}
                                                productPrice={item.oferta}
                                                productType={item.tipo_oferta}
                                                priceColor={props => props.theme[website]?.components.productBox.priceColor}
                                                announcedBy={item.empresa ? website : 'parceiro'}
                                                company={website}
                                            />
                                        </Grid>
                                    ))
                                        : <NothingMessage>
                                            Nenhuma oferta encontrada em Perto de Mim.
                                        </NothingMessage>}
                                </Grid>
                                <WrappLoadMore>
                                    {limitByUf <= offerByUf.length && (
                                        <Button
                                            styleType="bordered"
                                            buttonSize="small"
                                            buttonColor={props => props.theme[website]?.button.background}
                                            textColor={props => props.theme[website]?.button.color}
                                            borderColor={props => props.theme[website]?.button.background}
                                            buttonText="Mostrar mais ofertas"
                                            maxWidth={200}
                                            onClick={() => loadMoreUf()}
                                        />
                                    )}
                                </WrappLoadMore>
                            </Partners>
                        </WrapperPartners>
                    </Container>
                </TabPanel>

                <TabPanel value={tabValue} index={2} className="tabpanel">
                    <Container withContainer={true}>
                        <WrapperPartners>
                            <Partners>

                                {!!offerHighlight.length && (
                                    <Headline
                                        type="medium"
                                        title="Ofertas em destaque"
                                        subTitle="Confira abaixo todas as ofertas em destaque"
                                        textAlign="left"
                                    />
                                )}

                                {isLoading && (<Grid container spacing={0}>
                                    {[0, 1, 2, 3].map((item, i) =>
                                        <Grid key={`${item}-${i + 1}`} item xs={6}>
                                            <ProductLoader />
                                        </Grid>
                                    )}
                                </Grid>)}

                                <Grid container spacing={0}>
                                    {!!offerHighlight.length ? offerHighlight.map((item, i) => (
                                        <Grid key={`${item._id}-${i}`} item xs={6}>
                                            <ProductBox
                                                gridMargin={5}
                                                productId={item._id}
                                                discountValue={item.descont ? item.descont : null}
                                                productTitle={item.titulo}
                                                image={loadImage({ imageCode: item.imagens[0] })}
                                                productPrice={item.oferta}
                                                productType={item.tipo_oferta}
                                                priceColor={props => props.theme[website]?.components.productBox.priceColor}
                                                announcedBy={item.empresa ? website : 'parceiro'}
                                                company={website}
                                            />
                                        </Grid>
                                    ))
                                        : <NothingMessage>
                                            Nenhuma oferta encontrada em Destaque.
                                        </NothingMessage>}
                                </Grid>

                                <WrappLoadMore>
                                    {limitHighlight <= offerHighlight.length && (
                                        <Button
                                            styleType="bordered"
                                            buttonSize="small"
                                            buttonColor={props => props.theme[website]?.button.background}
                                            textColor={props => props.theme[website]?.button.color}
                                            borderColor={props => props.theme[website]?.button.background}
                                            buttonText="Mostrar mais ofertas"
                                            maxWidth={200}
                                            onClick={() => loadMoreHighlight()}
                                        />
                                    )}
                                </WrappLoadMore>
                            </Partners>
                        </WrapperPartners>
                    </Container>
                </TabPanel>

            </WrapperTabs>

        </Wrapper>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(Offers));